import React, { ReactNode } from 'react';
import { LinearProgress } from '@mui/material';

import classes from './SetupCustomerStepper.module.scss';
import { getPercentages } from '../../../utils/mathUtils';
import { BlackBgRow } from '../../ui-components';

export type StepOption = {
  title: string;
  description?: string;
  step: ReactNode;
};

type StepperProps = {
  activeStep: number;
  stepsConfig: StepOption[];
  title?: string;
};

const SetupCustomerStepper = ({
  activeStep,
  stepsConfig,
  title = 'LifeBase User Form',
}: StepperProps) => {
  const activeStepInfo = stepsConfig[activeStep];
  const stepsCount = stepsConfig.length;
  const activeStepNumber = activeStep + 1;
  const progress = getPercentages(activeStepNumber, stepsCount);

  return (
    <BlackBgRow bgRowHeight="404px">
      <div className={classes.stepperInfoRow}>
        <h5 className={classes.title}>{title}</h5>
        <div className={classes.stepInfo}>
          {activeStepNumber}/{stepsCount}
        </div>
      </div>
      <LinearProgress
        variant="determinate"
        value={progress}
        className={classes.linearProgress}
      />
      <div className={classes.stepTitleRow}>
        <h2 className={classes.title}>{activeStepInfo.title}</h2>
        {!!activeStepInfo.description && (
          <p className={classes.description}>{activeStepInfo.description}</p>
        )}
      </div>
      <div>{activeStepInfo.step}</div>
    </BlackBgRow>
  );
};

export { SetupCustomerStepper };
